import React from "react"
import styled from "styled-components"
import { Section, HeadingTwo, HeadingThree } from "../elements"
import { headerColor, fontHeading } from "../variables"

const IllustrationCollection = ({ slice }) => {
  const { title } = slice.primary

  return (
    <Section padding="60px 20px" width="100%">
      <HeadingTwo
        fontSize="36px"
        color={headerColor}
        textAlign="center"
        margin="0 0 50px 0"
      >
        {title.text}
      </HeadingTwo>
      <IllustrationContainer>
        {slice.items.map((item, i) => (
          <ContainerItem key={i}>
            <img src={item.illustration.url} alt={item.illustration.alt} />
            {item.title && (
              <>
                <HeadingThree
                  fontSize="22px"
                  fontWeight="700"
                  color={headerColor}
                  textTransform="uppercase"
                  letterSpacing="0.15em"
                  margin="24px 0 18px 0"
                >
                  {item.title.text}
                </HeadingThree>
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: item.content.html }}
                ></div>
              </>
            )}
          </ContainerItem>
        ))}
      </IllustrationContainer>
    </Section>
  )
}

export default IllustrationCollection

const IllustrationContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  max-width: 1196px;
  width: 100%;
  margin: 0 auto;
  grid-gap: 45px 175px;
`

const ContainerItem = styled.div`
  text-align: center;

  ${HeadingThree} {
    font-family: ${fontHeading};
  }

  img {
    width: auto;
    height: 65px;
  }

  .content {
    font-size: 17px;
    line-height: 1.6;
  }
`
